var map = {
	"./account_management.ts": 43688,
	"./balances_management.ts": 89190,
	"./business_units.ts": 80529,
	"./decision_engine.ts": 84038,
	"./fraud_manager.ts": 65489,
	"./instant_retry.ts": 29147,
	"./payment_links.ts": 55219,
	"./payments_search.ts": 46719,
	"./payouts_management.ts": 38708,
	"./reports.ts": 96164,
	"./services.ts": 45899,
	"./transactions_approval.ts": 90286,
	"./treasury_analytics.ts": 41537,
	"./virtual_terminal.ts": 38623,
	"./webhooks.ts": 50573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20203;